/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_UnlinkedInputs */

const zh_linked_unlinked = /** @type {(inputs: Linked_UnlinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解除绑定`)
};

const en_linked_unlinked = /** @type {(inputs: Linked_UnlinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account unlinked`)
};

const es_linked_unlinked = /** @type {(inputs: Linked_UnlinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta desvinculada`)
};

/**
* | output |
* | --- |
* | "Account unlinked" |
*
* @param {Linked_UnlinkedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const linked_unlinked = /** @type {((inputs?: Linked_UnlinkedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_UnlinkedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_unlinked(inputs)
	if (locale === "en") return en_linked_unlinked(inputs)
	return es_linked_unlinked(inputs)
});